if (!customElements.get('product-reviews')) {
  customElements.define(
    'product-reviews',
    class ProductReviews extends window.BAO.CustomElement {
      constructor () {
        super()

        this.querySelector(
          '[data-product-reviews-el="trigger"]'
        ).addEventListener('click', this.onClick)
      }

      onClick () {
        const target =
          window.BAO.utils.getElement(
            `[data-product-navigation-title="Reviews"]`
          ) || document.querySelector('.prd-Reviews')

        if (!target) return

        window.scrollTo({
          top: window.BAO.utils.getOffsetTop(target) - 120,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  )
}
